import { Button, Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { AppModels, ContactAttrs, RelatedContactAttrs, brandNewContact, contactSlice, contactValidator, hasErrors, relatedContactSlice, relatedContactValidator, saveModel } from 'cdx-common';
import React from 'react';
import { appStore } from '../../store';
import { ContactForm } from './Contact';


export const AddContact = (props: { onClose: () => void; }) => {

    const [contact, setContact] = React.useState<ContactAttrs>(brandNewContact);

    const [relatedContact, setRelatedContact] = React.useState<RelatedContactAttrs | undefined>();

    React.useEffect(() => {
        setContact({ ...brandNewContact });
    }, []);

    const update = (p: Partial<ContactAttrs>) => {
        setContact(q => {
            return { ...q, ...p };
        });
    };

    const onCreateClick = async () => {
        const validatedContact = await contactValidator.validate(contact);
        const validatedRelatedContact = relatedContact ? await relatedContactValidator.validate(relatedContact) : undefined;
        setContact(brandNewContact);
        if (!hasErrors(validatedContact) && (!validatedRelatedContact || !hasErrors(validatedRelatedContact))) {
            const newContact = await saveModel(AppModels.contacts, validatedContact);
            setContact(newContact);
            if (!hasErrors(newContact)) {
                appStore.dispatch(contactSlice.actions.upsertOne(newContact));
                if (validatedRelatedContact) {
                    const createdRelatedContact = await saveModel(AppModels.relatedContacts, {
                        ...validatedRelatedContact,
                        contactId: newContact.id
                    });
                    setRelatedContact(createdRelatedContact);
                    if (!hasErrors(createdRelatedContact)) {
                        appStore.dispatch(relatedContactSlice.actions.upsertOne(createdRelatedContact));
                        props.onClose();
                    }
                } else {
                    props.onClose();
                }
            }
        }
    };

    return <Dialog open={true} onClose={props.onClose}>
        <DialogContent>
            <DialogTitle>Nouveau contact</DialogTitle>
            <ContactForm contact={contact} update={update} compact />
            <Grid container spacing={2} columns={2}>
                <Grid item xs={2} alignContent='center'>
                    <Button color='primary' onClick={onCreateClick}>Créer</Button>
                    <Button color='secondary' onClick={props.onClose}>Annuler</Button>
                </Grid>
            </Grid>
        </DialogContent>
    </Dialog>;
}; 
